import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Breadcrumb } from '@vestiaire/api-sdk-angular';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '@app/core/services/routing.service';
import { UrlGeneratorService } from '@app/core/i18n';
import { take } from 'rxjs/operators';

@Component({
  selector: 'vc-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbComponent implements OnInit, AfterViewInit {
  currentPath: string;
  completeUrl = '';

  @Input()
  items: Array<Breadcrumb> = [];
  @Input()
  isCatalogPage: boolean | null;
  @Input()
  isMobile: boolean;

  @ViewChild('mainBreadcrumb', { read: ElementRef, static: false })
  private mainBreadcrumb: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private routingService: RoutingService,
    private urlGenerator: UrlGeneratorService
  ) {}

  ngOnInit(): void {
    this.route.root.firstChild.url.pipe(take(1)).subscribe(
      url => {
        this.currentPath = this.routingService.buildPath(url);
        this.completeUrl = this.urlGenerator.generateUrl(this.currentPath);
      },
      err => (this.currentPath = '')
    );
  }

  ngAfterViewInit(): void {
    if (this.isMobile) {
      this.mainBreadcrumb.nativeElement.scrollLeft = 500;
    }
  }

  isActiveItem(path: string): boolean {
    return this.currentPath === path;
  }
}
